import * as o from "react";
import p from "../lib/IconBase.es.js";
import r from "../defs/UploadSimple.es.js";
const e = o.forwardRef((a, m) => /* @__PURE__ */ o.createElement(p, { ref: m, ...a, weights: r }));
e.displayName = "UploadSimpleIcon";
const l = e;
export {
  l as UploadSimple,
  e as UploadSimpleIcon
};
